import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import styled from "styled-components";

const AddNoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 330px;
`;

const PaymentFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

const paymentTypeOptions = [
  { label: "Cash", value: "Cash" },
  { label: "Check", value: "Check" },
  { label: "Financing", value: "CareCredit" },
];

export interface IPaymentNoteData {
  isPaymentNote: boolean;
  paymentAmount: number | null;
  paymentType: string | null;
}

export function AddNoteDialog({
  showDialog,
  setShowDialog,
  note,
  setNote,
  paymentData,
  setPaymentData,
  onAddNote,
  orderPaymentNotesEnabled,
}: {
  showDialog: boolean;
  setShowDialog: any;
  note: string;
  setNote: any;
  paymentData: IPaymentNoteData;
  setPaymentData: (data: IPaymentNoteData) => void;
  onAddNote: any;
  orderPaymentNotesEnabled?: boolean;
}) {
  const resetForm = () => {
    setNote("");
    setPaymentData({
      isPaymentNote: false,
      paymentAmount: null,
      paymentType: null,
    });
  };

  const isAddDisabled = () => {
    if (!note.trim().length) return true;
    if (paymentData.isPaymentNote) {
      return !paymentData.paymentAmount || !paymentData.paymentType;
    }
    return false;
  };

  const footerComponent = () => {
    return (
      <div>
        <Button
          label="Cancel"
          onClick={() => {
            resetForm();
            setShowDialog(false);
          }}
          className="p-button-link mr-2"
        />
        <Button
          label="Add"
          onClick={() => {
            onAddNote();
          }}
          disabled={isAddDisabled()}
        />
      </div>
    );
  };
  return (
    <Dialog
      onHide={() => {
        resetForm();
        setShowDialog(false);
      }}
      visible={showDialog}
      header="Add Note"
      footer={footerComponent}
    >
      <AddNoteContainer>
        <span>Please, add your note here!</span>
        <InputTextarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={2}
          placeholder="Notes"
          className="w-full mt-3"
        />
        {orderPaymentNotesEnabled && (
          <>
            <div className="flex align-items-center mt-3">
              <Checkbox
                inputId="isPaymentNote"
                checked={paymentData.isPaymentNote}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    isPaymentNote: e.checked ?? false,
                    paymentAmount: e.checked ? paymentData.paymentAmount : null,
                    paymentType: e.checked ? paymentData.paymentType : null,
                  })
                }
              />
              <span className="ml-2 cursor-pointer">
                This is a payment note.
              </span>
            </div>
            {paymentData.isPaymentNote && (
              <PaymentFieldsContainer>
                <div className="flex flex-column gap-2">
                  <label htmlFor="paymentAmount">Payment Amount</label>
                  <InputNumber
                    inputId="paymentAmount"
                    value={paymentData.paymentAmount}
                    onValueChange={(e) =>
                      setPaymentData({
                        ...paymentData,
                        paymentAmount: e.value ?? null,
                      })
                    }
                    mode="currency"
                    currency="USD"
                    locale="en-US"
                    placeholder="Enter payment amount"
                    className="w-full"
                  />
                </div>
                <div className="flex flex-column gap-2">
                  <label htmlFor="paymentType">Payment Type</label>
                  <Dropdown
                    inputId="paymentType"
                    value={paymentData.paymentType}
                    onChange={(e) =>
                      setPaymentData({
                        ...paymentData,
                        paymentType: e.value,
                      })
                    }
                    options={paymentTypeOptions}
                    placeholder="Select payment type"
                    className="w-full"
                  />
                </div>
              </PaymentFieldsContainer>
            )}
          </>
        )}
      </AddNoteContainer>
    </Dialog>
  );
}
